<template lang="pug">
.input-file.center
  input.input-file-hidden(type="file" ref="fileInput" @change="setFiles" accept="image/*" :multiple="multiple")
  shActionButton(text="Seleccionar Imágenes" textRunning="Seleccionando Imágenes" :action="clickFileInput")
</template>

<script>
import mForm from '@/mixins/form'

export default {
  name: 'InputFile',

  mixins: [mForm],

  props: {
    multiple: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      fileList: {}
    }
  },

  methods: {
    setFiles (e) {
      const files = e.target.files || e.dataTransfer.files
      this.fileList = files
      this.$emit('change', files)
    },
    clickFileInput () {
      this.$refs.fileInput.click()
    }
  }
}
</script>

<style lang="stylus">
.input-file-hidden
  display none
</style>



// WEBPACK FOOTER //
// src/components/elements/InputFile.vue